import { useEffect } from "react";

/**
 * 判断是否为“纯手机”设备（排除 iPad 和其他平板）
 */
function isPhoneDevice() {
  const ua = navigator.userAgent;
  const isMobile = /Android|iPhone|Mobile/i.test(ua);
  const isTablet = /iPad|Tablet|Nexus 7|Nexus 10|KFAPWI/i.test(ua);
  const isNarrowScreen = window.innerWidth <= 768;
  return isMobile && !isTablet && isNarrowScreen;
}

/**
 * 等待页面出现 .gs-image-scalable 元素后，监听全局点击事件，
 * 在点击时执行你传入的回调函数（如滚动到顶部）。
 *
 * @param onClick 页面点击后的回调处理函数
 */
export function useGsImageClickListener(onClick: (e: MouseEvent) => void) {
  useEffect(() => {
    if (!isPhoneDevice()) {
      return;
    }
    let observer: MutationObserver | null = null;

    const clickHandler = (e: MouseEvent) => {
      onClick(e);
    };

    observer = new MutationObserver((_, obs) => {
      const gsImageBox = document.querySelector(".gs-image-scalable");
      if (gsImageBox) {
        document.addEventListener("click", clickHandler);
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      document.removeEventListener("click", clickHandler);
    };
  }, [onClick]);
}
